module.exports =
{

  _init: function ()
  {
    APPLICATION.WifiGuarantee.modals.createPopup.setupModal("terms")
  },

}